export default "__VITE_ASSET__b3a236fd__"